import { Separator, Token } from '@revolut-internal/ui-kit'
import { PanelResizeHandle } from 'react-resizable-panels'
import styled from 'styled-components'

const StyledPanelResizeHandle = styled(PanelResizeHandle)`
  padding-left: ${Token.space.s4};
  padding-right: ${Token.space.s4};
`

export const ResizeHandle = () => (
  <StyledPanelResizeHandle>
    <Separator orientation="vertical" bg="grouped-background" role={undefined} />
  </StyledPanelResizeHandle>
)
